export default {
    computed: {
        mapEditorState() {
            return this.$store.state.mapEditor;
        },
        mapDebug() {
            return this.mapEditorState.debug;
        },
        isDebugVisible() {
            return this.mapDebug.enabled === true;
        },
        isMapDebugVisible() {
            return this.mapDebug.enabled === true && this.mapDebug.map === true;
        },
        debugSettings() {
            return this.mapDebug;
        },
        isPanoDebugVisible() {
            return this.mapDebug.enabled === true && this.mapDebug.pano === true;
        },
        isPathDebugVisible() {
            return this.mapDebug.enabled === true && this.mapDebug.path === true;
        },
        currentMap() {
            return this.mapEditorState.map;
        },
        currentFloor() {
            return this.mapEditorState.floor;
        },
        isCurrentLocationOnSite() {
            return this.mapEditorState.isCurrentLocationOnSite;
        },
        debugMenuVisibility: {
            get() {
                return this.mapDebug.menuVisible;
            },
            set(value) {
                this.mapDebug.menuVisible = value;
            }
        },
        freeNavigation: {
            get() {
                return this.mapDebug.freeNavigation;
            },
            set(value) {
                this.mapDebug.freeNavigation = value;
            }
        },
        emulateGPS: {
            get() {
                return this.mapDebug.emulateGPS;
            },
            set(value) {
                this.mapDebug.emulateGPS = value;
            }
        },
        noisyGPS: {
            get() {
                return this.mapDebug.noisyGPS;
            },
            set(value) {
                this.mapDebug.noisyGPS = value;
            }
        },
        debugPedometerWithoutGps: {
            get() {
                return this.mapDebug.pedometerWithoutGps;
            },
            set(value) {
                this.mapDebug.pedometerWithoutGps = value;
            }
        },
        disableOrientation: {
            get() {
                return this.mapDebug.disableOrientation;
            },
            set(value) {
                this.mapDebug.disableOrientation = value;
            }
        },
        showArPanoGridInLive: {
            get() {
                return this.mapDebug.showArPanoGridInLive;
            },
            set(value) {
                this.mapDebug.showArPanoGridInLive = value;
            }
        },
        debugOrientation() {
            return this.mapDebug.orientation;
        },
        navSettings: {
            get() {
                return this.mapEditorState.navSettings;
            },
            set(value) {
                this.mapEditorState.navSettings = value;
            }
        },
        /**
         * CMS Wayfinding integrations settings
         * @returns {MapIntegrations} MapIntegrations object with the status of each integration
         */
        mapIntegrations() {
            return this.mapEditorState.map.integrations;
        },
        isQrCodeEnabled() {
            return this.mapIntegrations.isQrCodeEnabled() && this.isMobileDevice;
        }
    },
    methods: {
        applyUIScale(value = 1) {
            return value * this.mapEditorState.map.style.uiScale;
        },
        getScaleCSS(sizeInPixel) {
            return `calc(${sizeInPixel}px * var(--px-to-svg))`;
        },
        pxToMeters(pxCoordinate) {
            return pxCoordinate * this.mapEditorState.floor.scale / 100;
        },
        metersToPx(mCoordinate) {
            return mCoordinate / this.mapEditorState.floor.scale * 100;
        }
    }
}
